





































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import {
    PipelinePhaseCategory, ReferralAge,
    ReferralFilterDirection, ReferralStatus,
    ReferralView,
} from '@/api/types'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { ReferralStats } from '@/api/model/referral-stats'
import { getColorForPhaseCategory, getColorForStatus } from '@/helpers/color'
import { EventBus } from './EventBus'
import { NavigationOptionProps } from '@/components/ui/navigation/NavigationOption.vue'
const referrals = namespace('referrals')

@Component
export default class SubNavigationLeadTabs extends Vue {
    @referrals.State readonly view!: ReferralView
    @referrals.State readonly direction!: ReferralFilterDirection
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @referrals.State readonly phaseFilter!: PipelinePhase
    @referrals.State readonly phaseCategoryFilter!: PipelinePhaseCategory
    @referrals.State readonly statusFilter!: string
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.Getter readonly selectedPipeline!: Pipeline | null
    @referrals.Action applyView: ({view: ReferralView, direction: ReferralFilterDirection}) => Promise<void>
    @referrals.Action applyStatusFilter: ({statusFilter: string}) => Promise<void>
    @referrals.Action applyPipelineFilter: ({id: string}) => Promise<void>
    @referrals.Action applyPipelinePhaseFilter: ({phase: PipelinePhase}) => Promise<void>
    @referrals.Action applyPipelinePhaseCategoryFilter: ({category: PipelinePhaseCategory}) => Promise<void>
    @referrals.Action applyAgeFilter: ({ageFilter: ReferralAge}) => Promise<void>
    @referrals.Action applyScoreFilter: ({scoreFilter: []}) => Promise<void>
    @referrals.Action snapshot: () => Promise<void>

    ensureListerIsLoaded(): void {
        if (this.$route.name !== 'tasks_all') {
            this.$router.push({name: 'tasks_all'})
        }
    }

    hideNavigation(): void {
        this.snapshot()
        EventBus.$emit('close')
    }

    setView(view: ReferralView, direction: ReferralFilterDirection) {
        this.applyView({view, direction})
    }

    setPipelineFilter(id: string) {
        this.applyPipelineFilter({id})
    }

    setPhaseFilter(phase: PipelinePhase): void {
        this.ensureListerIsLoaded()
        this.applyPipelinePhaseFilter({phase})
        this.hideNavigation()
    }

    setPhaseCategoryFilter(category: PipelinePhaseCategory): void {
        this.ensureListerIsLoaded()
        this.applyPipelinePhaseCategoryFilter({category})
        this.hideNavigation()
    }

    setStatusFilter(status: ReferralStatus | string): void {
        this.ensureListerIsLoaded()
        this.applyStatusFilter({statusFilter: status})
        this.hideNavigation()
    }

    setAgeFilter(ageFilter: ReferralAge): void {
        this.ensureListerIsLoaded()
        this.applyAgeFilter({ageFilter})
        this.hideNavigation()
    }

    setScoreFilter(score: number): void {
        this.ensureListerIsLoaded()
        this.applyScoreFilter({scoreFilter: [score]})
        this.hideNavigation()
    }

    get viewOptions(): Array<NavigationOptionProps<ReferralView>> {
        return [
            {
                label: this.$t('navigation.leads_menu.my_leads').toString(),
                value: 'user',
                active: this.view === 'user',
                hideCount: true,
            },
            {
                label: this.$t('navigation.leads_menu.team_leads').toString(),
                value: 'branches',
                active: this.view === 'branches',
                hideCount: true,
            },
        ]
    }

    get directionOptions(): Array<NavigationOptionProps<ReferralFilterDirection>> {
        return [
            {
                label: this.$t(`navigation.leads_menu.${this.view === 'user' ? 'my' : 'team'}_referred`).toString(),
                value: 'in',
                active: this.direction === 'in',
                hideCount: true,
            },
            {
                label: this.$t(`navigation.leads_menu.${this.view === 'user' ? 'my' : 'team'}_created`).toString(),
                value: 'out',
                active: this.direction === 'out',
                hideCount: true,
            },
        ]
    }

    get pipelineOptions(): Array<NavigationOptionProps<string | null>> {
        return [
            {
                label: this.$t('pipelineFilters.all').toString(),
                value: null,
                count: this.referralStats.countsForAllPipelines,
                active: this.selectedPipeline === null,
            },
            ...this.pipelines.map(entry => ({
                label: entry.name,
                value: entry.id,
                count: this.referralStats.countForPipeline(entry),
                active: this.selectedPipeline?.id === entry.id,
            })),
        ]
    }

    get phaseOptions(): Array<NavigationOptionProps<PipelinePhase>> {
        if (!this.selectedPipeline) {
            return []
        }

        return this.selectedPipeline.activePhases.map(entry => ({
            label: entry.name,
            value: entry,
            count: this.referralStats.countForPhase(entry.id),
            color: entry.color,
            active: this.phaseFilter?.id === entry.id,
        }))
    }

    get categoryOptions(): Array<NavigationOptionProps<PipelinePhaseCategory>> {
        const categories = [
            PipelinePhaseCategory.ENTRY,
            PipelinePhaseCategory.APPROACH,
            PipelinePhaseCategory.DECISION,
        ]

        return categories.map(category => ({
            label: this.$t(`pipeline-phase.category.${category}`).toString(),
            value: category,
            count: this.referralStats.countForCategory(category),
            color: getColorForPhaseCategory(category),
            active: this.phaseCategoryFilter === category,
        }))
    }

    get statusOptions(): Array<NavigationOptionProps<string>> {
        return [
            ReferralStatus.PROCESSED,
            ReferralStatus.SUCCESSFUL,
            ReferralStatus.CLOSED,

        ].map(status => ({
            label: this.$t(`navigation.leads_menu.statuses.${status}`).toString(),
            value: status,
            count: this.referralStats.countForStatus(status),
            color: getColorForStatus(status),
            active: this.statusFilter === status,
        }))
    }
}
